import { getConfig } from "../Config";

export async function getPreSignedURL(file) {

    let url = getConfig().serverUrl + "/getSignedUrl/" + file.name + "/" + file.type.replace("/", "&ACTUALLYFORWARDSLASH&");

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getPreSignedGETURL(name, type) {

    let url = getConfig().serverUrl + "/getSignedGETUrl/" + name + "/" + type.replace("/", "&ACTUALLYFORWARDSLASH&");

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function uploadToS3(file) {
    let url = getConfig().serverUrl + "/addWork/" + file.name + "/" + file.size;
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });

}

export async function getSpecies() {
    let url = getConfig().serverUrl + "/getSpecieTable";
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function addSpecie(latin, english) {
    let url = getConfig().serverUrl + "/addSpecie";
    return await fetch(url, {
        method: "POST",
        body: JSON.stringify({latinName: latin, englishName: english})
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getTranslations() {
    let url = getConfig().serverUrl + "/getTranslationTable";
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function addTranslation(specie, region, translate, symbol) {
    let url = getConfig().serverUrl + "/addTranslation";
    return await fetch(url, {
        method: "POST",
        body: JSON.stringify({specieId: specie, regionCode: region, translation: translate, symbol: symbol})
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}


export async function getRegions() {
    let url = getConfig().serverUrl + "/getRegionTable";
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function addRegion(regionCode, regionName) {
    let url = getConfig().serverUrl + "/addRegion";
    return await fetch(url, {
        method: "POST",
        body: JSON.stringify({regionCode: regionCode, regionName: regionName})
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function removeSpecie(id) {
    let url = getConfig().serverUrl + "/removeSpecie/"+id;
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}
export async function removeTranslation(id) {
    let url = getConfig().serverUrl + "/removeTranslation/"+id;
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function removeRegion(id) {
    let url = getConfig().serverUrl + "/removeRegion/"+id;
    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getSamplesByUser(accessToken, page) {
    return getCall("getSamplesByUser/" + page, accessToken)
}

export async function getCompanyRelation(accessToken) {
    return getCall("getCompanyRelation", accessToken)
}

export async function getUsersByCompany(accessToken) {
    return getCall("getCompanyCustomers", accessToken);
}

export async function getCompanyWhitelist(accessToken) {
    return getCall("getCompanyWhitelist", accessToken);
}

export async function getCompanyKeys(accessToken) {
    return getCall("getCompanyKeys", accessToken)
}

export async function addToCompanyWhitelist(body) {
    return postCall("addToCompanyWhitelist", body, body.cognitoToken);
}

export async function generateApiKey(key) {
    return postCall("generateApiKey", {}, key)
}

export async function deleteCompanyKey(id, accessToken) {
    return deleteCall("deleteCompanyKey", {id: id}, accessToken)
}

export async function deleteCustomerFromCompany(id, accessToken) {
    return deleteCall("deleteCustomerFromCompany", {id: id}, accessToken)
}

async function getCall(endpoint, token) {
    let url = getConfig().serverUrl + "/" + endpoint;
    return await fetch(url, {
        method: "GET",
        headers: new Headers({
            'Authorization': 'Token ' + token,
        }),
        }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

async function postCall(endpoint, body, key) {
    let url = getConfig().serverUrl + "/"+endpoint;

    return await fetch(url, {
        method: "POST",
        headers: new Headers({
            'Authorization': 'Token ' + key,
        }),
        body: JSON.stringify(body)
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

async function deleteCall(endpoint, body, key) {
    let url = getConfig().serverUrl + "/" + endpoint;

    return await fetch(url, {
        method: "DELETE",
        headers: new Headers({
            'Authorization': 'Token ' + key,
        }),
        body: JSON.stringify(body)
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function addLoginRecord(cognitoToken) {
    let url = getConfig().serverUrl + "/recordWebLogin";
    return await fetch(url, {
        method: "POST",
        body: JSON.stringify({cognitoToken: cognitoToken})
    }).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}